import { clientMethods, ChatMessage } from "server/src/clientExports";
import { connect, Socket } from "socket.io-client";
import create from "zustand";
import { differenceInDays } from "date-fns";
import { checkStartupPopup, saveChatLastOpenedTime } from "../util/popup";

const IS_LOCALHOST =
  (document.location.hostname === "localhost" ||
    document.location.hostname.startsWith("192.168")) &&
  process.env.NODE_ENV !== "production";

const SOCKET_URL = IS_LOCALHOST ? "http://localhost:8000" : "https://chat.abhedayoga.ro";

console.log("Socket URL", SOCKET_URL);
interface ChatState {
  connected: boolean;
  visible: boolean;
  loggedIn: boolean;
  userId?: string;
  username?: string;
  chatSocket?: Socket;
  scrollToBottom: boolean;
  showPopup: boolean;
  tokens: {
    facebook?: string;
    google?: string;
  };
  messages: ChatMessage[];
  actions: {
    showChat: (visible?: boolean) => void;
    connect: () => Promise<void>;
    setShowPopup: (showPopup: boolean) => void;
    disconnectFromChat: () => void;
    setUsername: (value: string) => void;
    sendChatMessage: (message: string) => void;
    disableAutoScroll: () => void;
    setGoogleToken: (token: string | undefined) => void;
    loginWithFacebook: (username: string) => void;
    loginWithGoogle: (username: string, googleToken: string) => void;
    logout: () => void;
  };
}

const setUpSocketListeners = (
  socket: Socket,
  get: () => ChatState,
  set: (
    partial:
      | ChatState
      | Partial<ChatState>
      | ((state: ChatState) => ChatState | Partial<ChatState>),
    replace?: boolean | undefined
  ) => void
) => {
  clientMethods.onChatConnectionValid(socket, (payload) => {
    set({
      messages: payload.messages,
      userId: payload.userId
    });
  });
  clientMethods.onChatMessageRecieved(socket, (message) => {
    const chatState = get();
    set({
      messages: [...chatState.messages, message]
    });
  });
};

const getFacebookLoginToken = (): Promise<string> => {
  const anyWindow = window as any;
  return new Promise((resolve) => {
    anyWindow.FB.getLoginStatus(function (response: any) {
      const facebook = response?.authResponse?.accessToken || undefined;

      if (facebook) {
        resolve(facebook);
      } else {
        anyWindow.FB.login(() => {
          anyWindow.FB.getLoginStatus(function (response: any) {
            const facebook = response?.authResponse?.accessToken || undefined;

            resolve(facebook);
          });
        });
      }
    });
  });
};

(window as any)["onFacebookAuth"] = () => {
  // (window as any).FB.getLoginStatus(function (response: any) {
  //   const facebook = response?.authResponse?.accessToken || undefined;
  //   useChatStore.setState({
  //     tokens: {
  //       facebook
  //     }
  //   });
  // });
};

(window as any)["onGoogleAuth"] = (user: any) => {
  console.log("google status", user);

  const google = user.credential || undefined;
  useChatStore.setState({
    tokens: {
      google
    }
  });
};
window.addEventListener("facebookLoaded", () => {
  (window as any)["onFacebookAuth"]();
});

export const useChatStore = create<ChatState>((set, get) => {
  return {
    connected: false,
    visible: false,
    userId: undefined,
    loggedIn: false,
    username: undefined,
    chatSocket: undefined,
    scrollToBottom: true,
    showPopup: IS_LOCALHOST ? true : checkStartupPopup(),
    tokens: {},
    messages: [],
    actions: {
      showChat: (visible = true) => {
        set({
          visible
        });
      },
      connect: async () => {
        const chatSocket = connect(SOCKET_URL);
        const { connected } = get();
        if (connected) {
          return;
        }

        set({
          connected: true,
          chatSocket
        });
        setUpSocketListeners(chatSocket, get, set);
      },
      setShowPopup: (showPopup: boolean) => {
        if (showPopup) {
          saveChatLastOpenedTime();
        }
        set({
          showPopup
        });
      },
      loginWithFacebook: async (username: string) => {
        const { chatSocket } = get();
        if (!chatSocket) {
          return;
        }
        let token = "";
        // TOOD comment this so we don't forget to check fb login in dev env
        // if (process.env.NODE_ENV === "development") {
        //   token = "development-token";
        // } else {
        token = await getFacebookLoginToken();
        // }

        clientMethods.loginWithFacebook(chatSocket, username, token);
        set({
          username,
          loggedIn: true
        });
      },
      loginWithGoogle: async (username: string, token: string) => {
        const { chatSocket } = get();
        if (!chatSocket) {
          return;
        }

        clientMethods.loginWithGoogle(chatSocket, username, token);
        set({
          username,
          loggedIn: true
        });

        localStorage.setItem(
          "radio-om-bun-chat-login",
          JSON.stringify({
            username,
            type: "google"
          })
        );
      },
      logout: () => {
        set({
          username: undefined,
          loggedIn: false
        });
      },
      disconnectFromChat: () => {
        const { chatSocket } = get();
        if (chatSocket) {
          chatSocket.disconnect();
        }
        set({
          connected: false,
          username: undefined,
          userId: undefined,
          chatSocket: undefined
        });
      },
      setUsername: (value: string) => {
        set({
          username: value
        });
      },
      sendChatMessage: (message: string) => {
        const { chatSocket, username } = get();
        if (!chatSocket || !username) {
          return;
        }
        clientMethods.sendChatMessage(chatSocket, username, message);
      },
      disableAutoScroll: () => {
        set({
          scrollToBottom: false
        });
      },
      setGoogleToken: (token) => {
        set({
          tokens: {
            google: token
          }
        });
      }
    }
  };
});

export const useChatData = () =>
  useChatStore(({ visible, username, connected, loggedIn, userId }) => {
    return {
      visible,
      username,
      userId,
      connected,
      loggedIn
    };
  });
export const useChatTokens = () =>
  useChatStore((state) => {
    return state.tokens;
  });
export const useChatMessages = () => useChatStore((store) => store.messages);

export const useChatActions = () => useChatStore((store) => store.actions);
